import React, { Suspense } from 'react';
import { AppReadyHelper } from '@sas/nova-commons/components/AppRoot/AppReadyHelper';
import cx from 'classnames';
import { useLocaleTextDir } from '../../config';
//css
import cn from './ReportContentWrapper.css.json';
import './ReportContentWrapper.css';
export const ReportContentWrapper = (props) => {
    const direction = useLocaleTextDir();
    return (React.createElement("div", { className: cx(props.className, cn.wrapper), dir: direction, style: props.style },
        React.createElement(Suspense, { fallback: 
            // AppReadyHelper renders null and emits an event when suspense is lifted.
            // This is needed to fix DOM measurement issues in Nova (VASDK-1045)
            // but should no longer be necessary with React 18.
            React.createElement(AppReadyHelper, null) }, props.children)));
};
